import React from 'react';

export interface ChartHudItem {
  label: string;
  value: React.ReactNode;
  color?: string;
  variant?: 'pos' | 'neg' | 'default';
  valueClassName?: string;
}

export interface InstitutionalChartHudProps {
  items?: ChartHudItem[];
  meta?: React.ReactNode;
  placeholder?: React.ReactNode;
  className?: string;
  children?: React.ReactNode;
}

export const InstitutionalChartHud: React.FC<InstitutionalChartHudProps> = ({
  items,
  meta,
  placeholder = 'Hover over chart bars to inspect institutional metrics',
  className = '',
  children,
}) => {
  return (
    <div className={`ns-inst-chart-hud ${className}`}>
      {children ? (
        children
      ) : items && items.length > 0 ? (
        <div className="ns-inst-chart-hud__items">
          {items.map((item, idx) => {
            const variantClass =
              item.variant === 'pos'
                ? 'ns-inst-chart-hud__val--pos ns-fiidii-val--pos'
                : item.variant === 'neg'
                ? 'ns-inst-chart-hud__val--neg ns-fiidii-val--neg'
                : '';

            return (
              <div key={idx} className="ns-inst-chart-hud__item">
                <span className="ns-inst-chart-hud__label">{item.label}</span>
                <strong
                  className={`ns-inst-chart-hud__val ${variantClass} ${item.valueClassName || ''}`}
                  style={item.color ? { color: item.color } : undefined}
                >
                  {item.value}
                </strong>
              </div>
            );
          })}
        </div>
      ) : (
        <span className="ns-inst-chart-hud__label">{placeholder}</span>
      )}

      {meta && <div className="ns-inst-chart-hud__meta">{meta}</div>}
    </div>
  );
};

export default InstitutionalChartHud;
